'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TIME_OUT = 300;
var DISPLAY_TIME = 1500;

/**
* @description: toast组件
* @param: {isShow=false} 是否显示
* @param: {msg} string 显示的话术
* @param: {timeout=1500} int 显示的时间 
* @param: {?clsFn} function 关闭后的回调
*/

var ToastComponent = function (_React$Component) {
    _inherits(ToastComponent, _React$Component);

    function ToastComponent(props) {
        _classCallCheck(this, ToastComponent);

        /*
         * 初始化state
         * */
        var _this = _possibleConstructorReturn(this, (ToastComponent.__proto__ || Object.getPrototypeOf(ToastComponent)).call(this, props));

        _this.state = {
            marginTop: 0,
            marginLeft: 0,
            hasShow: false,
            displayStr: 'none',
            id: 'j_toast' + Date.now()
        };

        _this.animationInClass = 'ani-upin';
        _this.animationOutClass = 'ani-upout';
        _this.originClass = 'toast';
        _this.className = _this.originClass + ' ' + _this.animationInClass;
        _this.timer = undefined;
        return _this;
    }

    _createClass(ToastComponent, [{
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var dom = document.getElementById(this.state.id);
            var marginTop = -Math.floor(dom.clientHeight / 2),
                marginLeft = -Math.floor(dom.clientWidth / 2);

            if (this.state.marginTop != marginTop || this.state.marginLeft != marginLeft) {
                this.setState({
                    marginTop: marginTop,
                    marginLeft: marginLeft
                });
            }
        }
    }, {
        key: 'show',
        value: function show(param) {
            this.setShow(param);
            this.delayToHide(param && param.timeout);
        }
    }, {
        key: 'setShow',
        value: function setShow(param) {
            this.className = this.originClass + ' ' + this.animationInClass;
            this.setState({
                hasShow: true,
                displayStr: '',
                msg: param && param.msg
            });
            //兼容没有原生event的机器
            if (!this.hasAddAnimationEventHandler) {
                this.hasAddAnimationEventHandler = true;
                var dom = document.getElementById(this.state.id);
                dom.addEventListener('WebkitAnimationEnd', this.animationEndHandler.bind(this));
            }
        }
    }, {
        key: 'hide',
        value: function hide() {
            this.setHide();
        }
    }, {
        key: 'setHide',
        value: function setHide() {
            this.className = this.originClass + ' ' + this.animationOutClass;
            this.setState({
                hasShow: false
            });
        }
    }, {
        key: 'delayToHide',
        value: function delayToHide(timeout) {
            var _this2 = this;

            clearTimeout(this.timer);
            this.timer = setTimeout(function () {
                _this2.setHide();
            }, timeout || TIME_OUT + DISPLAY_TIME);
        }
    }, {
        key: 'animationEndHandler',
        value: function animationEndHandler() {
            if (!this.state.hasShow) {
                this.setState({
                    displayStr: 'none',
                    hasShow: false
                });
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { id: this.state.id, onAnimationEnd: this.animationEndHandler.bind(this), ref: 'toast', style: { marginTop: this.state.marginTop, marginLeft: this.state.marginLeft, display: this.state.displayStr }, className: this.className },
                this.state.msg
            );
        }
    }]);

    return ToastComponent;
}(_react2.default.Component);

exports.default = ToastComponent;